module.exports = __webpack_public_path__ + "img/chevron-down.555fbf6b.svg";